export default __webpack_public_path__ + "static/media/item1.a026c285.jpg";